import { AnalyticsFragment } from 'services/graphql/fragments/VxlFragments';
import { IconFragment } from 'services/graphql/fragments/VxlStyles';
import { gql } from 'urql';

const GetEligibleNonEligibleDetails = gql`
  query VaroLineOfCreditPageV2($input: VlocPageInputV2Input!) {
    varoLineOfCreditPageV2(input: $input) {
      ... on EducationalScreenV2 {
        body {
          ... on TextComponent {
            copy
            id
            __typename
          }
          ... on BulletComponent {
            id
            bulletItems: items
            __typename
          }
          ... on IconTextComponent {
            items {
              copy
              id
              icon {
                ...IconFragment
              }
              __typename
            }
            __typename
          }
        }
        disclaimer
        footer {
          ... on ButtonComponentV2 {
            buttonOnClick {
              ... on SDUserInformationAction {
                analyticsEvent {
                  ...analytics
                }
                id
                __typename
              }
              ... on SDContinueClientFlowAction {
                id
                __typename
              }
              ... on SDEducationalScreenAction {
                educationalScreenId
                id
                __typename
              }
              ... on VlocPageNavigationAction {
                vlocPageID
                id
                __typename
              }
            }
            buttonStyle
            buttonText
            id
            __typename
          }
        }
        header {
          ... on ImageHeaderComponentV2 {
            id
            image {
              fallbackURL
              id
              illustrationKey
              __typename
            }
            __typename
          }
          ... on TextComponent {
            copy
            id
            __typename
          }
        }
        displayAnalytics {
          ...analytics
        }
        __typename
      }
      ... on VlocPageDataError {
        code
        message
        title
        __typename
      }
    }
  }
  ${AnalyticsFragment}
  ${IconFragment}
`;

export default GetEligibleNonEligibleDetails;
